import { createRoot } from 'react-dom/client';

import 'rc-tooltip/assets/bootstrap.css';
import './assets/scss/index.scss';
import { Routes } from './routes/Routes';

createRoot(document.getElementById('root')!).render(<Routes />);
